import { Component,OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Location } from '@angular/common';

@Component({

selector:'app-service-enquiry',

templateUrl:'./service-enquiry.component.html',

styleUrls:['./service-enquiry.component.scss']

})

export class ServiceEnquiryComponent implements OnInit{


serviceId:any;

service:any;

merchantId:any;

message='';


userId:any;



constructor(

private route:ActivatedRoute,

private apiService:ApiServiceService,

private router:Router,
private location:Location

){}



ngOnInit(){


this.userId =
localStorage.getItem('profileId');


this.serviceId =
this.route.snapshot.paramMap.get('id');


this.loadService();


}

  goBack(): void {
  this.location.back();
}

loadService(){


this.apiService
.getServiceDetails(this.serviceId)
.subscribe({

next:(res:any)=>{

this.service=res.data;

this.merchantId =
this.service.merchantId ||
this.service.merchant_id;


},

error:(err)=>{

console.log(err);

}

});


}



submitEnquiry(){


if(!this.message.trim()){

alert(
"Please enter enquiry message"
);

return;

}



const data={


user_id:this.userId,


merchant_id:this.merchantId,


service_id:this.serviceId,


service_name:this.service.service_name,


message:this.message


};



this.apiService
.createServiceEnquiry(data)
.subscribe({

next:(res:any)=>{


alert(
"Enquiry sent successfully"
);


this.router.navigate(
[
'/wedding-services'
]
);


},

error:(err)=>{

console.log(err);

}

});


}



}